import { Component, Fragment } from 'react';
import { postData, putData, getData } from "../../servicos/api";
import { isAdmin } from "../../servicos/auth";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Form, FormGroup, Label, Input, Button, Card, CardHeader, CardBody, CardFooter } from 'reactstrap';
import Navbar from '../../Components/Navbar';
import Sidebar from '../../Components/Sidebar';
import ModalResponse from '../../Components/ModalResponse';
import Combobox from '../../Components/Combobox';
import { Link } from "react-router-dom";
import Switch from 'react-switch';

//REDUX
import { setLoaderShow, setResponseModal } from '../../reducers/index';
import { connect } from 'react-redux';

const Formulario = (props) => {
    let estabelecimento;
    if (props.data && props.data.estabelecimento_id !== undefined && props.data.estabelecimento_id !== null && props.listaEstabelecimentos.length > 0) {
        estabelecimento = props.listaEstabelecimentos.filter(function (elem, i, object) {
            return elem.value === props.data.estabelecimento_id;
        });
        if(estabelecimento[0] !== undefined){
            estabelecimento = { value: estabelecimento[0].value, label: estabelecimento[0].label };
        }
    }

    let validarAdmin = Yup.object({
        nome: Yup.string()
            .min(2, 'O campo nome deverá ter no mínimo 2 caracteres.')
            .max(90, 'O campo nome deverá ter no máximo 90 caracteres.')
            .required('O campo nome é obrigatório.')
            .trim(),
        estabelecimento_id: Yup.object()
            .required('O campo estabelecimento é obrigatório.'),
    });

    let validarEstabelecimento = Yup.object({
        nome: Yup.string()
            .min(2, 'O campo nome deverá ter no mínimo 2 caracteres.')
            .max(90, 'O campo nome deverá ter no máximo 90 caracteres.')
            .required('O campo nome é obrigatório.')
            .trim(),
    });

    const formik = useFormik({
        initialValues: {
            nome:  props.data !== undefined && props.data !== null ? props.data.nome : '',
            ativo: props.data !== undefined && props.data !== null ? !!parseInt(props.data.ativo) : true,
            estabelecimento_id: estabelecimento
        },
        enableReinitialize: true,
        validationSchema: isAdmin() ? validarAdmin : validarEstabelecimento,
        onSubmit: values => {
            let data = {
                "nome" : values.nome,
                "estabelecimento_id": values.estabelecimento_id || (isAdmin()) ? values.estabelecimento_id.value : null,
                "ativo": values.ativo,
            }

            if (props.operation !== undefined && props.operation !== null && props.operation === 'alt') {
                props.updateDiaIdeal(data, props.data.uuid);
            } else {
                props.insertDiaIdeal(data);
            }
        },
    });
    return ( 
        <Form className="forms-sample col-12" onSubmit={formik.handleSubmit}>
            <Card>
                <CardHeader className="bg-maskats text-center">
                    <h4 className="headerTitle">Cadastro de dias ideais</h4>
                </CardHeader>
                <CardBody>
                    <div>

                        {
                            isAdmin() ? 
                                <FormGroup>
                                    <Label for="estabelecimento_id">* Estabelecimento</Label>
                                    <Combobox
                                        invalid={formik.touched.estabelecimento_id && formik.errors.estabelecimento_id}
                                        valid={formik.touched.estabelecimento_id && !formik.errors.estabelecimento_id}
                                        id="estabelecimento_id"
                                        name="estabelecimento_id"
                                        placeholder={'Selecione um item'}
                                        defaultValue={formik.values.estabelecimento_id}
                                        value={formik.values.estabelecimento_id}
                                        options={props.listaEstabelecimentos}
                                        isMulti={false}
                                        loadingMessage={"Carregando..."}
                                        noOptionsMessage={"Não existem dados cadastrados."}
                                        onChange={formik.setFieldValue}
                                        onBlur={formik.setFieldTouched}
                                        maxMenuHeight={190}
                                    />
                                    {formik.touched.estabelecimento_id && formik.errors.estabelecimento_id ? (
                                        <div className="divError">{formik.errors.estabelecimento_id}</div>
                                    ) : null}
                                </FormGroup>
                            : ""
                        }

                        <FormGroup>
                            <Label for="nome">* Nome</Label>
                            <Input 
                                className="form-control form-control-sm" 
                                id="nome" 
                                name="nome" 
                                type="text" 
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.nome}
                                maxLength={90}
                            />
                            {formik.touched.nome && formik.errors.nome ? (
                                <div className="divError">{formik.errors.nome}</div>
                            ) : null}
                        </FormGroup>

                        <FormGroup className="mb-0">
                            <Label for="ativo">Ativo</Label>
                            <br />
                            <Switch
                                id="ativo"
                                name="ativo"
                                onColor="#28a745"
                                offColor="#dc3545"
                                checked={formik.values.ativo}
                                onChange={()=>formik.setFieldValue('ativo', !formik.values.ativo)}
                            />
                        </FormGroup>
                    </div>
                </CardBody>
                <CardFooter className="text-align-end bg-white">
                    <Link replace to="/dia-ideal">
                        <Button className="mr-2 text-white btn btn-sm btn-secondary btn-fw bd-rd-8" type="button">
                            <i className="fa fa-arrow-left btn-icon-append btn-fs-def"></i>
                            <span className="label-button btn-fs-def">Cancelar</span>
                        </Button>
                    </Link>

                    <Button className="btn btn-sm btn-success btn-fw bd-rd-8" type="submit">
                        <i className="fa fa-check btn-icon-append btn-fs-def"></i>
                        <span className="label-button btn-fs-def">Salvar</span>
                    </Button>
                </CardFooter>
            </Card>
        </Form>
    );
}

class DiaIdealFormulario extends Component {
    constructor(props){
        super(props);

        this.state = {
            listaEstabelecimentos: [],
        };
        
        this.loadingShow    = this.loadingShow.bind(this);
        this.updateDiaIdeal = this.updateDiaIdeal.bind(this);
        this.insertDiaIdeal = this.insertDiaIdeal.bind(this);
    }

    async componentDidMount(){
        this.loadingShow(true);

        let listaEstabelecimentos = [];

        listaEstabelecimentos = await getData(`/estabelecimento`, this.props);
        if(listaEstabelecimentos !== null){
            listaEstabelecimentos = listaEstabelecimentos.map(function (value) {
                return { value: value.id, label: value.nome, ativo: value.ativo };
            });
        }

        this.setState({listaEstabelecimentos});

        this.loadingShow(false);
    }

    loadingShow(value) {
        let { setLoaderShow } = this.props;
        setLoaderShow(value);
    }

    async updateDiaIdeal(data, uuid){
        this.loadingShow(true);
        await putData(`/dia-ideal/${uuid}`, this.props, data, '../dia-ideal');
        this.loadingShow(false);
    }

    async insertDiaIdeal(data){
        this.loadingShow(true);
        await postData(`/dia-ideal`, this.props, data, '../dia-ideal');
        this.loadingShow(false);
    }

    render(){
        const { data, operation } = this.props.location;
        const { setResponseModal, enableResponseModal } = this.props;
        return (
            <Fragment>
                <div className="container-scroller">
                    <Navbar/>
                    <div className="container-fluid page-body-wrapper">
                        <Sidebar/>
                        <div className="main-panel">
                            <div className="content-wrapper">
                                <div className="row">
                                    <div className="col-md-12 grid-margin stretch-card">
                                        <Formulario
                                            data={data}
                                            operation={operation}
                                            updateDiaIdeal={this.updateDiaIdeal}
                                            insertDiaIdeal={this.insertDiaIdeal}
                                            listaEstabelecimentos={this.state.listaEstabelecimentos}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalResponse 
                    history={this.props.history} 
                    setResponseModal={setResponseModal} 
                    enableResponseModal={enableResponseModal}
                />
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        enableLoaderShow: state.enableLoaderShow,
        enableResponseModal: state.enableResponseModal,
    }
};

const mapDispatchToProps = dispatch => ({
    setLoaderShow: enable => dispatch(setLoaderShow(enable)),
    setResponseModal: enable => dispatch(setResponseModal(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DiaIdealFormulario);